import React from "react";

const ProcedureTextDetails = ({ procedureDetailData }) => {
  return (
    <div className="info">
      {procedureDetailData.resource.reason && (
        <div className="label">
          <span className="label">Reason - </span>
          {procedureDetailData.resource.reason[0].concept.text}
        </div>
      )}
      <div>
        <span className="label">Surgery Performed - </span>
        {procedureDetailData.resource.code.coding[0].display ||
          procedureDetailData.resource.code.text}
      </div>
      {procedureDetailData.resource.code.coding[0].code && (
        <div>
          <span className="label">Snowmed - </span>
          {procedureDetailData.resource.code.coding[0].code}
        </div>
      )}
      {procedureDetailData.resource.note && (
        <div>
          <h1 className="label">Operative Findings</h1>
          {procedureDetailData.resource.note.map((item) => (
            <div>{item.text}</div>
          ))}
        </div>
      )}
      {/* <div>
        <h3 className="label">Post Operatives</h3>
        {procedureDetailData.fol}
      </div> */}
    </div>
  );
};

export default ProcedureTextDetails;
